module.exports = __webpack_public_path__ + "img/Yogurt-Nan-400x263.dff72cd2.jpg";